// Coming Soon / password page behaviour.
//
// This lives in an external asset (not an inline <script>) on purpose: the
// Shopify password page serves a Content-Security-Policy that blocks inline
// scripts, so any inline JS silently never runs.
//
// Signup strategy: the form submits *natively* (a normal top-level Shopify
// submit) because that is the only path that actually subscribes the customer
// to email marketing. That means the page reloads — but the section is rendered
// in a "settled" state on that reload (see pw--settled in the section), so the
// intro animation does NOT replay; it lands straight on the finished screen
// with the success message showing. We also save to Supabase and remember the
// browser (localStorage) so return visits skip the email box entirely.
(function () {
  'use strict';

  var SUBMITTED_KEY = 'ajae_newsletter_submitted';
  var SUPABASE_URL = 'https://smohhlblozzcmjrvntsb.supabase.co';
  var SUPABASE_ANON_KEY =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNtb2hobGJsb3p6Y21qcnZudHNiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ5NjA2ODcsImV4cCI6MjA5MDUzNjY4N30.YRWNdC2Zhrv4UhogmTdqe2AUko7sUVXbAWdARQyDK8w';

  function hasSubmitted() {
    try {
      return localStorage.getItem(SUBMITTED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markSubmitted() {
    try {
      localStorage.setItem(SUBMITTED_KEY, '1');
    } catch (e) {}
  }

  function saveToSupabase(email) {
    // keepalive lets this complete even though the page is navigating away.
    try {
      fetch(SUPABASE_URL + '/rest/v1/subscribers', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          apikey: SUPABASE_ANON_KEY,
          Authorization: 'Bearer ' + SUPABASE_ANON_KEY,
          Prefer: 'resolution=merge-duplicates,return=minimal',
        },
        body: JSON.stringify({ email: email, accepts_email_marketing: true }),
        keepalive: true,
      }).catch(function () {});
    } catch (e) {}
  }

  // Show the finished state without any intro animation.
  function settle(form) {
    var section = form.querySelector('.pw') || document.querySelector('.pw');
    if (section) section.classList.add('pw--settled');

    var row = form.querySelector('[data-pw-row]');
    var success = form.querySelector('[data-pw-success]');
    if (row) row.classList.add('pw__row--closed');
    if (success) success.classList.add('is-visible');
  }

  function initForm() {
    var forms = document.querySelectorAll('form.newsletter-form');

    Array.prototype.forEach.call(forms, function (form) {
      var success = form.querySelector('[data-pw-success]');
      if (!success || form.dataset.pwBound) return;
      form.dataset.pwBound = '1';

      // Returning visitor (or the post-submit reload): show the message, no box,
      // no intro animation.
      if (hasSubmitted()) {
        settle(form);
        return;
      }

      // Fresh visitor: let the form submit natively (Shopify subscribes them and
      // reloads into the settled state). We just record the email in Supabase and
      // remember this browser on the way out — no preventDefault.
      form.addEventListener('submit', function () {
        var input = form.querySelector('input[type="email"]');
        var email = input ? (input.value || '').trim() : '';
        if (!email) return; // native validation will have blocked anyway
        saveToSupabase(email);
        markSubmitted();
      });
    });
  }

  // ---- Background video: keep it playing on iOS/Safari/in-app browsers -------
  function initVideo() {
    var video = document.querySelector('.pw__video');
    if (!video) return;

    function play() {
      video.muted = true;
      video.loop = true;
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
    }

    video.addEventListener('ended', function () {
      try {
        video.currentTime = 0;
      } catch (e) {}
      play();
    });

    play();
    setTimeout(play, 250);
    setTimeout(play, 1000);

    window.addEventListener('pointerdown', play, { once: true });
    window.addEventListener('keydown', play, { once: true });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) play();
    });
  }

  function init() {
    initVideo();
    initForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
